<template>
  <section class="w-100 px-4 d-flex flex-column justify-content-center align-items-center">
    <h1 class="font-weight-bold">このビデオ通話は現在利用できません。</h1>
  </section>
</template>

<script>
  export default {
    name: 'InvalidRoom'
  }
</script>
